module.exports = __webpack_public_path__ + "static/media/0_2019_07_01.6fb762b3.jpg";